import { format, parseISO } from 'date-fns';

export const formatLastUsed = (lastUsedAt: string | null): string => {
  if (!lastUsedAt) return 'Never';
  try {
    return format(parseISO(lastUsedAt), 'PPP p');
  } catch {
    return 'Never';
  }
};
